
<script setup>
import { usePageScale } from "@/assets/usePageScale.js"

// 假设设计稿宽度 1920，高度 1080，按宽度缩放
const {scaleStyle, wrapperStyle } = usePageScale(1300, 6135, "width")
</script>
<template>
 <!-- <div class="scale-container" :style="scaleStyle">
    <HelloWorld msg="Welcome to aosi"/>
  </div> -->
  <div>
    <!-- 外层 wrapper 负责撑开真实大小 -->
    <div class="wrapper" :style="wrapperStyle">
      <!-- 内层 scale-container 负责缩放 -->
      <div class="scale-container" :style="scaleStyle">
        <HelloWorld msg="Welcome to aosi"/>

        <div style="font-size: 8px;color: #999;">
          备案号：
          <a style="color: #999;" href="https://beian.miit.gov.cn/" target="_blank">湘ICP备2025138328号</a>
        </div>
      </div>
    </div>
  </div>
  
  
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
  /* 保证外层可以滚动 */
  * {
    margin: 0;
    padding: 0;
  }

  .scale-container {
    min-height: 100vh;
    overflow-y: auto;
  }

</style>
